import { get } from 'lodash';
import React, { useContext, useMemo } from 'react';
import Context from '~/App/Modules/TodoList/Context';
import { Button } from '@vimily/bonjoro-ui-components-v2/Button';
import { ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';
import cx from 'classnames';
import useCurrentUser from '~/react-hooks/use-current-user';

export interface SortTogglerProps {
  className?: string;
}

export function SortToggler({ className }: SortTogglerProps) {
  const { id: userId } = useCurrentUser();
  const { setSortOrder, sortOrder: sortOrders } = useContext(Context);
  const sortOrder = get(sortOrders, userId) || '-updated_at';

  const onSortToggle = () => {
    switch (sortOrder) {
      case '+updated_at':
        setSortOrder({ ...sortOrders, [userId]: '-updated_at' });
        break;
      case '-updated_at':
        setSortOrder({ ...sortOrders, [userId]: '+updated_at' });
        break;
      default:
        throw new Error('Invalid sort order');
    }
  };

  const { label, iconClassName } = useMemo(() => {
    switch (sortOrder) {
      case '+updated_at':
        return {
          label: 'Oldest',
          iconClassName: 'icon-sort-oldest',
        };
      case '-updated_at':
      default:
        return {
          label: 'Newest',
          iconClassName: 'icon-sort-newest',
        };
    }
  }, [sortOrder]);

  return (
    <Button
      variant={ButtonVariant.Secondary}
      className={cx(className, [
        'w-[115px] font-thin flex gap-x-1.5 border-none justify-between items-center',
        'v2-text-neutral-900 font-circular text-base h-10 select-none',
      ])}
      onClick={onSortToggle}
    >
      {label}
      <i className={`icon ${iconClassName}`} />
    </Button>
  );
}
